import { render, staticRenderFns } from "./DFoot.vue?vue&type=template&id=1fefbb76&scoped=true&"
import script from "./DFoot.vue?vue&type=script&lang=js&"
export * from "./DFoot.vue?vue&type=script&lang=js&"
import style0 from "./DFoot.vue?vue&type=style&index=0&id=1fefbb76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fefbb76",
  null
  
)

export default component.exports